// Common OBD-II Diagnostic Trouble Codes with plain-English descriptions.
// Focused on the most-encountered P codes (powertrain) with a smattering of B/U codes.
export const DTC_CODES = [
  // Fuel & Air Metering
  { code: "P0100", desc: "Mass or Volume Air Flow Circuit Malfunction" },
  { code: "P0101", desc: "MAF Sensor Range/Performance" },
  { code: "P0102", desc: "MAF Sensor Circuit Low Input" },
  { code: "P0103", desc: "MAF Sensor Circuit High Input" },
  { code: "P0106", desc: "MAP/BARO Sensor Range/Performance" },
  { code: "P0107", desc: "MAP Sensor Circuit Low Input" },
  { code: "P0108", desc: "MAP Sensor Circuit High Input" },
  { code: "P0110", desc: "Intake Air Temperature Circuit Malfunction" },
  { code: "P0112", desc: "IAT Sensor Circuit Low" },
  { code: "P0113", desc: "IAT Sensor Circuit High" },
  { code: "P0115", desc: "Engine Coolant Temp Circuit" },
  { code: "P0117", desc: "ECT Sensor Circuit Low" },
  { code: "P0118", desc: "ECT Sensor Circuit High" },
  { code: "P0120", desc: "Throttle Position Sensor Circuit" },
  { code: "P0121", desc: "TPS Range/Performance" },
  { code: "P0122", desc: "TPS Circuit Low" },
  { code: "P0123", desc: "TPS Circuit High" },
  { code: "P0128", desc: "Coolant Temperature Below Thermostat Regulating Temp" },

  // O2 Sensors
  { code: "P0130", desc: "O2 Sensor Circuit (Bank 1 Sensor 1)" },
  { code: "P0131", desc: "O2 Sensor Low Voltage (B1S1)" },
  { code: "P0132", desc: "O2 Sensor High Voltage (B1S1)" },
  { code: "P0133", desc: "O2 Sensor Slow Response (B1S1)" },
  { code: "P0134", desc: "O2 Sensor No Activity (B1S1)" },
  { code: "P0135", desc: "O2 Sensor Heater Circuit (B1S1)" },
  { code: "P0136", desc: "O2 Sensor Circuit (B1S2)" },
  { code: "P0137", desc: "O2 Sensor Low Voltage (B1S2)" },
  { code: "P0138", desc: "O2 Sensor High Voltage (B1S2)" },
  { code: "P0141", desc: "O2 Sensor Heater Circuit (B1S2)" },
  { code: "P0150", desc: "O2 Sensor Circuit (B2S1)" },
  { code: "P0151", desc: "O2 Sensor Low Voltage (B2S1)" },
  { code: "P0152", desc: "O2 Sensor High Voltage (B2S1)" },
  { code: "P0155", desc: "O2 Sensor Heater Circuit (B2S1)" },

  // Fuel & Fuel Trim
  { code: "P0170", desc: "Fuel Trim Malfunction (Bank 1)" },
  { code: "P0171", desc: "System Too Lean (Bank 1)" },
  { code: "P0172", desc: "System Too Rich (Bank 1)" },
  { code: "P0173", desc: "Fuel Trim Malfunction (Bank 2)" },
  { code: "P0174", desc: "System Too Lean (Bank 2)" },
  { code: "P0175", desc: "System Too Rich (Bank 2)" },
  { code: "P0190", desc: "Fuel Rail Pressure Sensor Circuit" },
  { code: "P0191", desc: "Fuel Rail Pressure Sensor Range/Performance" },
  { code: "P0193", desc: "Fuel Rail Pressure Sensor Circuit High Input" },

  // Injectors
  { code: "P0201", desc: "Injector Circuit Malfunction Cylinder 1" },
  { code: "P0202", desc: "Injector Circuit Malfunction Cylinder 2" },
  { code: "P0203", desc: "Injector Circuit Malfunction Cylinder 3" },
  { code: "P0204", desc: "Injector Circuit Malfunction Cylinder 4" },
  { code: "P0205", desc: "Injector Circuit Malfunction Cylinder 5" },
  { code: "P0206", desc: "Injector Circuit Malfunction Cylinder 6" },
  { code: "P0207", desc: "Injector Circuit Malfunction Cylinder 7" },
  { code: "P0208", desc: "Injector Circuit Malfunction Cylinder 8" },

  // Misfire
  { code: "P0300", desc: "Random / Multiple Cylinder Misfire Detected" },
  { code: "P0301", desc: "Cylinder 1 Misfire Detected" },
  { code: "P0302", desc: "Cylinder 2 Misfire Detected" },
  { code: "P0303", desc: "Cylinder 3 Misfire Detected" },
  { code: "P0304", desc: "Cylinder 4 Misfire Detected" },
  { code: "P0305", desc: "Cylinder 5 Misfire Detected" },
  { code: "P0306", desc: "Cylinder 6 Misfire Detected" },
  { code: "P0307", desc: "Cylinder 7 Misfire Detected" },
  { code: "P0308", desc: "Cylinder 8 Misfire Detected" },
  { code: "P0316", desc: "Misfire Detected on Startup (First 1000 Revolutions)" },

  // Ignition
  { code: "P0325", desc: "Knock Sensor 1 Circuit (Bank 1)" },
  { code: "P0326", desc: "Knock Sensor 1 Range/Performance" },
  { code: "P0335", desc: "Crankshaft Position Sensor A Circuit" },
  { code: "P0336", desc: "CKP Sensor A Range/Performance" },
  { code: "P0340", desc: "Camshaft Position Sensor A Circuit" },
  { code: "P0341", desc: "CMP Sensor A Range/Performance" },
  { code: "P0351", desc: "Ignition Coil A Primary/Secondary Circuit" },
  { code: "P0352", desc: "Ignition Coil B Primary/Secondary Circuit" },
  { code: "P0353", desc: "Ignition Coil C Primary/Secondary Circuit" },
  { code: "P0354", desc: "Ignition Coil D Primary/Secondary Circuit" },
  { code: "P0355", desc: "Ignition Coil E Primary/Secondary Circuit" },
  { code: "P0356", desc: "Ignition Coil F Primary/Secondary Circuit" },

  // Emissions
  { code: "P0400", desc: "EGR Flow Malfunction" },
  { code: "P0401", desc: "EGR Flow Insufficient Detected" },
  { code: "P0402", desc: "EGR Flow Excessive Detected" },
  { code: "P0411", desc: "Secondary Air Injection Incorrect Flow" },
  { code: "P0420", desc: "Catalyst System Efficiency Below Threshold (Bank 1)" },
  { code: "P0430", desc: "Catalyst System Efficiency Below Threshold (Bank 2)" },
  { code: "P0440", desc: "Evaporative Emission Control System Malfunction" },
  { code: "P0441", desc: "EVAP Incorrect Purge Flow" },
  { code: "P0442", desc: "EVAP Small Leak Detected" },
  { code: "P0446", desc: "EVAP Vent Control Circuit" },
  { code: "P0455", desc: "EVAP Large Leak Detected" },
  { code: "P0456", desc: "EVAP Very Small Leak Detected" },

  // Vehicle Speed & Idle
  { code: "P0500", desc: "Vehicle Speed Sensor Malfunction" },
  { code: "P0505", desc: "Idle Air Control System Malfunction" },
  { code: "P0506", desc: "IAC RPM Lower Than Expected" },
  { code: "P0507", desc: "IAC RPM Higher Than Expected" },

  // Computer / Communications
  { code: "P0562", desc: "System Voltage Low" },
  { code: "P0563", desc: "System Voltage High" },
  { code: "P0601", desc: "Internal Control Module Memory Check Sum Error" },
  { code: "P0606", desc: "PCM Processor Fault" },

  // Transmission
  { code: "P0700", desc: "Transmission Control System Malfunction" },
  { code: "P0701", desc: "TCM Range/Performance" },
  { code: "P0711", desc: "Transmission Fluid Temperature Sensor Range/Performance" },
  { code: "P0715", desc: "Input/Turbine Speed Sensor Circuit" },
  { code: "P0720", desc: "Output Speed Sensor Circuit" },
  { code: "P0730", desc: "Incorrect Gear Ratio" },
  { code: "P0740", desc: "Torque Converter Clutch Circuit Malfunction" },
  { code: "P0741", desc: "TCC Circuit Performance / Stuck Off" },
  { code: "P0748", desc: "Pressure Control Solenoid A Electrical" },
  { code: "P0751", desc: "Shift Solenoid A Performance / Stuck Off" },

  // Body / Chassis / Network (samples)
  { code: "B0020", desc: "Front End Air Bag Deployment Control (Left)" },
  { code: "B1000", desc: "ECU Malfunction" },
  { code: "C0035", desc: "Left Front Wheel Speed Sensor Circuit" },
  { code: "C0040", desc: "Right Front Wheel Speed Sensor Circuit" },
  { code: "U0100", desc: "Lost Communication With ECM/PCM 'A'" },
  { code: "U0101", desc: "Lost Communication with TCM" },
  { code: "U0121", desc: "Lost Communication with ABS Control Module" },
  { code: "U0140", desc: "Lost Communication with Body Control Module" },
];
